import { Subject } from 'rxjs';

export const secondPanelOpenSubject$ = new Subject();
